import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CreateAccount from "components/User/CreateAccount";

const LandingCreateAccountOrLogin = ({ setSignUpOpen, setLoginOpen }: { setSignUpOpen: (open: boolean) => void; setLoginOpen: (open: boolean) => void }) => {
  return (
    <>
      <CreateAccount landingPage={true} />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h6">Already have an account?</Typography>
        <Button
          onClick={() => {
            setSignUpOpen(false);
            setLoginOpen(true);
          }}
        >
          Login
        </Button>
      </Box>
    </>
  );
};

export default LandingCreateAccountOrLogin;